import * as types from '../types/types_header';

export default {
  state: {
    title: '',
  },
  mutations: {
    [types.HEADER_SET_TITLE](state, newTitle) {
      state.title = newTitle || '';
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/ReportApp/store/modules/modules_header.js